export interface ApiResponse {
  result: any;
  message?: string;
}
